export default "__VITE_ASSET__CWyX0IiS__"